import { useState } from "react"
import s from "./faq.module.css"


export default function Faq({ colorFondo }) {
    const [button, setButton] = useState([
        false,
        false,
        false,
        false,
        false,
        false
    ])
    const [test, setTest] = useState(true)
    function handleSelect(number) {
        // console.log(button[number])
        console.log(button)
        let arr = button
        arr[number] = !arr[number]
        setButton(arr)
        setTest(!test)
    }
    return (
        // <section className={s.section}>
        <section className={s[colorFondo]}>
            <div className={s.container}>
                <span className={s.faq}>faq</span>
                <div className={s.faqContainer}>
                    <div className={s.pregunta} onClick={() => handleSelect(0)}><span className={s.text}>What is Venom?</span>{!button[0] ? <div className={s.flecha}></div> : <div className={s.flechaBaja}></div>}</div>
                    {button[0] && <div className={s.respuesta}><span className={s.respuestaText}>Venom is a Blockchain that will function as the main infrastructure for a global ecosystem of Web3 applications, possessing ultra-fast transaction speeds and infinite scalability to meet the demands of an ever-expanding user base.</span></div>}
                    <div className={s.pregunta} onClick={() => handleSelect(1)}><span className={s.text}>What wallet should i use?</span>{!button[1] ? <div className={s.flecha}></div> : <div className={s.flechaBaja}></div>}</div>
                    {button[1] && <div className={s.respuesta}> <span className={s.respuestaText}>You should use the official wallet called Venom Blockchain Wallet</span></div>}
                    <div className={s.pregunta} onClick={() => handleSelect(2)}><span className={s.text}>What is the supply of the project?</span>{!button[2] ? <div className={s.flecha}></div> : <div className={s.flechaBaja}></div>}</div>
                    {button[2] && <div className={s.respuesta}><span className={s.respuestaText}>More than 999 unique NFTs</span></div>}
                    <div className={s.pregunta} onClick={() => handleSelect(3)}><span className={s.text}>What is the mint price?</span>{!button[3] ? <div className={s.flecha}></div> : <div className={s.flechaBaja}></div>}</div>
                    {button[3] && <div className={s.respuesta}><span className={s.respuestaText}>Depends on Venom price
                    </span>
                    {/* <span className={s.respuestaText}>Public – 10 $CANTO
                    </span> */}
                    </div>}
                    <div className={s.pregunta} onClick={() => handleSelect(4)}><span className={s.text}>When will the mint take place?</span>{!button[4] ? <div className={s.flecha}></div> : <div className={s.flechaBaja}></div>}</div>
                    {button[4] && <div className={s.respuesta}><span className={s.respuestaText}>When Venom mainnet is available</span></div>}
                    <div className={s.pregunta} onClick={() => handleSelect(5)}><span className={s.text}>Where?</span>{!button[5] ? <div className={s.flecha}></div> : <div className={s.flechaBaja}></div>}</div>
                    {button[5] && <div className={s.respuesta}><span className={s.respuestaText}>On our web or in some launchpad</span></div>}

                </div>
            </div>
        </section>
    )
}